/**
 * SEAM S1 (slice 85) — the SOS wire contract, imported from the api (PLAN §9b).
 * `import type` only, the convention every alert type in `features/alerts/types.ts`
 * follows, so no api module graph reaches the web bundle and `tsc` fails here if the
 * two sides ever disagree.
 */
import type {
  SosAlert,
  ActiveSosResponse,
} from '../../../../api/src/modules/alerts/routes';

export type { SosAlert, ActiveSosResponse };

/** One item from `GET /api/alerts/active-sos`: the SOS plus the vehicle's current
 *  `driver` (null = unknown) and `driverPhone` (null = no Call button, D2). */
export type ActiveSosItem = ActiveSosResponse['sos'][number];

/** `POST /api/alerts/:id/acknowledge` (no body). Idempotent: a second ack returns
 *  the ORIGINAL who/when. Mirrors the api's `AcknowledgeResponseZ`. */
export interface AcknowledgeResponse {
  id: string;
  acknowledgedAt: string;
  acknowledgedBy: string;
  acknowledgedByName: string | null;
}

/** A still-open SOS is one with no acknowledgement recorded. The banner, the alarm
 *  and the flashing marker are all driven by this predicate, in one place. */
export function isOpenSos(item: { acknowledgedAt: string | null }): boolean {
  return item.acknowledgedAt == null;
}
